export default (phone) => {
  return 'whatsapp://send?phone=' + phone.replace(/\+|\s|-|\./g, '')
}
